import React, { useContext } from "react";
import { TouchableOpacity } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { Container, OuterContainer } from "./styles";
import { MenuIcon, BackIcon } from "myplan/components/Icon";
import { NavContext } from "myplan/utils/nav";

type DrawerButtonProps = {
    onGoBack?: () => void;
};

const DrawerButton = ({ onGoBack }: DrawerButtonProps) => {
    const navigation: any = useNavigation();
    const { canGoBack, goBack } = useContext(NavContext);
    const Icon = canGoBack ? BackIcon : MenuIcon;
    const width = canGoBack ? "40%" : "60%";
    const goBackFn = onGoBack || goBack;

    const onPress = canGoBack
        ? () => goBackFn()
        : () => navigation.openDrawer();

    return (
        <OuterContainer>
            <TouchableOpacity onPress={onPress}>
                <Container pointerEvents="box-none">
                    <Icon width={width} height={width} />
                </Container>
            </TouchableOpacity>
        </OuterContainer>
    );
};

export default DrawerButton;
